import { lazy } from "react";
import { PATH_URL } from "./constants";
import PolicyVticket from "../components/Pages/PolicyVticket";
const Policy = lazy(() => import("../components/Pages/Policy"))
const Terms = lazy(() => import("../components/Pages/Terms"))
const Login = lazy(() => import("../components/Login"))
const Redirect = lazy(() => import("../components/Redirect"))

export const routes = [
   {
      path: PATH_URL.LOGIN,
      element: <Login />
   },
   {
      path: PATH_URL.POLICY,
      element: <Policy />
   },
   {
      path: PATH_URL.POLICY_VTICKET,
      element: <PolicyVticket />
   },
   // {
   //    path: PATH_URL.TERMS,
   //    element: <Terms />
   // },
   {
      path: "*",
      element: <Redirect />
   }
]